module.exports = __webpack_public_path__ + "static/topimage-ece4bab8c4c711adf9b7a03547556a09.png";